import { FeeValue } from '@/types';

/**
 * TCX-866: a fee is `{ type, value, note }`. The object itself is always
 * defined once a franchisor has touched the field (even after clearing it), so
 * "is this fee filled in" has to look at `value`, the same rule the backend's
 * `hasFeeValue` applies (non-whitespace content). Used by the profile
 * completeness bar, so a cleared fee never counts as complete (TCX-865).
 */
export function isFeeFilled(fee: FeeValue | undefined | null): boolean {
  return !!fee?.value?.trim();
}
